import React from 'react';
import intl from 'react-intl-universal';
import { getParameterByName } from '../../querystring.js';

const locales = {
    'pt-BR': require('../../locales/pt-BR.json'),
    'en-US': require('../../locales/en-US.json'),
    'es-ES': require('../../locales/es-ES.json')
};

export function Setp1(props) {

    const querystring = getParameterByName('lang');

    const language = querystring ? querystring : navigator.language;

    const currentLocale = locales[language] ? language : 'pt-BR';

    intl.init({
        currentLocale,
        locales
    });

    return (
        <div className="row step">
            <div className="col-xs-12">
                <div className="text-center">
                    <h3 className="title">{intl.get('steps.step')}</h3>
                    <h2>{intl.get('steps.step01')}</h2>
                    <span className="pont">{intl.get('steps.step02')}</span>
                </div>
                <div className="detractor">
              {intl.get('steps.step04')}
              </div>
              <div className="neutros">
              {intl.get('steps.step05')}
              </div>
              <div className="promotores">
              {intl.get('steps.step06')}
              </div>
            </div>
           
            {props.children}
        </div>
    );
}